import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import BlogCard from './BlogCard';

const BlogList = () => {
    const [blogs, setBlogs] = useState([]);
    const [activeCat, setActiveCat] = useState('Բոլորը');
    const [visibleCount, setVisibleCount] = useState(6); // Սկզբնական քանակը
    const [loading, setLoading] = useState(false);

    const API_BASE = 'https://api.liber.am';
    const goldColor = '#c5a059';

    const categories = ['Բոլորը', 'Հատուկ առաջարկներ', 'Հետաքրքիր', 'Օգտակար խորհուրդներ', 'Նորություններ'];

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await axios.get(`${API_BASE}/api/blogs`);
                setBlogs(res.data);
            } catch (err) {
                console.error("🔥 Error fetching blogs:", err);
            }
        };
        fetchBlogs();
        window.scrollTo(0, 0);
    }, []);

    // 1. Ֆիլտրում ենք ըստ կատեգորիայի
    const filteredBlogs = activeCat === 'Բոլորը' 
        ? blogs 
        : blogs.filter(b => b.category === activeCat);

    // 2. Վերցնում ենք միայն տեսանելի քանակը
    const blogsToShow = filteredBlogs.slice(0, visibleCount);

    // 3. Load More ֆունկցիա՝ թեթև loading էֆեկտով
    const handleLoadMore = () => {
        setLoading(true);
        setTimeout(() => {
            setVisibleCount(prev => prev + 3);
            setLoading(false);
        }, 600); // Փոքր դադար սիրունության համար
    };

    return (
        <div style={{ background: '#0a0a0b', minHeight: '100vh', paddingBottom: '100px' }}>
            <Helmet>
                
                <title>Բլոգ | LIBER Premium Logistics Insights</title>
                <meta property="og:title" content="LIBER Premium Logistics Blog" />
               <meta property="og:url" content="https://liber.am/blog" />
               <link rel="canonical" href="https://liber.am/blog" />
                <meta name="description" content="Կարդացեք լոգիստիկայի ոլորտի ամենաթարմ նորությունները և օգտակար խորհուրդները LIBER-ի բլոգում:" />
            </Helmet>

            <style>
                {`
                    @keyframes fadeInDown {
                        from { opacity: 0; transform: translateY(-20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes spin {
                        to { transform: rotate(360deg); }
                    }
                    .hero-text { animation: fadeInDown 1s ease forwards; }
                    .cat-pill { transition: all 0.4s ease; border: 1px solid rgba(255,255,255,0.05) !important; }
                    .cat-pill:hover { border-color: ${goldColor} !important; transform: translateY(-2px); }
                    .load-more-btn:disabled { opacity: 0.6; cursor: not-allowed; }
                `}
            </style>

            {/* --- 1. PREMIUM HEADER --- */}
            <div style={{ position: 'relative', padding: '220px 20px 120px', textAlign: 'center', background: 'radial-gradient(circle at top, #1a1a1c 0%, #0a0a0b 100%)', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: '10%', left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: '800px', height: '400px', background: `radial-gradient(circle, ${goldColor}08 0%, transparent 70%)`, zIndex: 1 }} />
                <div className="hero-text" style={{ position: 'relative', zIndex: 2 }}>
                    <span style={{ color: goldColor, letterSpacing: '8px', fontWeight: '800', fontSize: '12px', textTransform: 'uppercase', display: 'block', marginBottom: '20px' }}>Liber Premium Services</span>
                    <h1 style={{ color: '#fff', fontSize: 'clamp(45px, 8vw, 80px)', fontWeight: '900', margin: '0', lineHeight: '0.8', textTransform: 'uppercase', letterSpacing: '-2px' }}>
                        ՄԵՐ <span style={{ color: 'transparent', WebkitTextStroke: `1px ${goldColor}`, fontStyle: 'italic' }}>ԲԼՈԳԸ</span>
                    </h1>
                    <div style={{ width: '40px', height: '2px', background: goldColor, margin: '35px auto' }} />
                    <p style={{ color: 'rgba(255,255,255,0.5)', maxWidth: '600px', margin: '0 auto', fontSize: '18px', lineHeight: '1.7', fontWeight: '300' }}>Մասնագիտական մոտեցում տեղափոխման և լոգիստիկայի յուրաքանչյուր մանրուքին:</p>
                </div>
            </div>

            {/* --- 2. STICKY FILTER --- */}
            <div style={{ position: 'sticky', top: '80px', zIndex: 100, marginTop: '-40px', padding: '0 20px' }}>
                <div style={{ maxWidth: 'fit-content', margin: '0 auto', background: 'rgba(20, 20, 22, 0.7)', backdropFilter: 'blur(15px)', padding: '8px', borderRadius: '100px', border: '1px solid rgba(255,255,255,0.08)', boxShadow: '0 20px 40px rgba(0,0,0,0.4)', display: 'flex', gap: '5px', flexWrap: 'wrap', justifyContent: 'center' }}>
                    {categories.map(cat => (
                        <button key={cat} onClick={() => { setActiveCat(cat); setVisibleCount(6); }} className="cat-pill" style={{ padding: '12px 25px', borderRadius: '50px', border: 'none', background: activeCat === cat ? goldColor : 'transparent', color: activeCat === cat ? '#000' : '#fff', cursor: 'pointer', fontWeight: '700', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                            {cat}
                        </button>
                    ))}
                </div>
            </div>

            {/* --- 3. BLOG GRID --- */}
            <div style={{ maxWidth: '1250px', margin: '80px auto 0', padding: '0 25px' }}>
                {blogsToShow.length > 0 ? (
                    <>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '50px 30px' }}>
                            {blogsToShow.map((item) => (
                                <Link to={`/blog/${item.slug}`} key={item.id} style={{ textDecoration: 'none' }}>
                                    <BlogCard item={item} />
                                </Link>
                            ))}
                        </div>

                        {/* LOAD MORE SECTION */}
                        {visibleCount < filteredBlogs.length && (
                            <div style={{ textAlign: 'center', marginTop: '70px' }}>
                                <button 
                                    className="load-more-btn"
                                    onClick={handleLoadMore}
                                    disabled={loading}
                                    style={{
                                        padding: '16px 45px',
                                        background: 'transparent',
                                        border: `1px solid ${goldColor}`,
                                        color: goldColor,
                                        borderRadius: '50px',
                                        fontSize: '13px',
                                        fontWeight: '800',
                                        cursor: 'pointer',
                                        letterSpacing: '2px',
                                        textTransform: 'uppercase',
                                        transition: '0.3s',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}
                                >
                                    {loading ? (
                                        <>
                                            <div style={{ width: '18px', height: '18px', border: '2px solid rgba(197, 160, 89, 0.3)', borderTopColor: goldColor, borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                                            Բեռնվում է...
                                        </>
                                    ) : 'Բեռնել ավելին'}
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <div style={{ textAlign: 'center', padding: '100px 0' }}>
                        <h3 style={{ color: '#444', fontSize: '20px' }}>Այս բաժնում դեռ նյութեր չկան</h3>
                        <button onClick={() => setActiveCat('Բոլորը')} style={{ color: goldColor, background: 'none', border: `1px solid ${goldColor}`, padding: '10px 25px', borderRadius: '50px', marginTop: '20px', cursor: 'pointer' }}>Վերադառնալ բոլորին</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BlogList;